import React, { useMemo } from 'react';

import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { BRAND_COLORS } from 'brand-guidelines/colors';
import { selectDataUser } from 'connect/selectors';
import { PartnerLogo } from 'pages/common/components/PartnerLogo/PartnerLogo';
import OpencareLogoSvg from 'pages/common/components/svgs/OpencareLogoSvg';
import {
  DIMENSIONS,
  useWindowDimensions,
} from 'providers/WindowDimensionsProvider';

import { useIsPartnerUser } from 'utils/customHooks/use-partner-user';

import { CheckoutTimer } from './CheckoutTimer/CheckoutTimer';
import {
  LogoWrapper,
  NavbarContainer,
  NavbarContent,
} from './Navbar-styled-components';
import { SecureBadge } from './SecureBadge/SecureBadge';

const LOGO_HEIGHT = '30px';

export const Navbar = () => {
  const { layout } = useWindowDimensions();
  const isMobile = layout === DIMENSIONS.MOBILE;
  const showLogoText = !isMobile;

  const { clinicId } = useParams<{ clinicId: string; }>();

  const user = useSelector(selectDataUser);

  const clinicUrl = useMemo(() => {
    return `/results/${clinicId || ''}`;
  }, [clinicId]);

  const isPartnerUser = useIsPartnerUser();

  return (
    <NavbarContainer>
      <NavbarContent>
        <LogoWrapper aria-label="Return to practice profile" to={clinicUrl}>
          <OpencareLogoSvg
            hideContainer
            height={LOGO_HEIGHT}
            withText={showLogoText}
            color={BRAND_COLORS.darkGray}
          />
        </LogoWrapper>

        {isPartnerUser ? <PartnerLogo partner={user?.partner} /> : <CheckoutTimer />}

        <SecureBadge />
      </NavbarContent>
    </NavbarContainer>
  );
};
